function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#C7C9D9",
  d: "M0 0h3v3H0zM0 4.5h3v3H0zM0 9h3v3H0zM4.5 0h3v3h-3zM4.5 4.5h3v3h-3zM4.5 9h3v3h-3zM9 0h3v3H9zM9 4.5h3v3H9zM9 9h3v3H9z"
});

function SvgColumnTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgColumnTag;